/**
 * Sayt matnlari va namunaviy kontent.
 *
 * E'lonlar va g'oliblar keyinchalik admin paneldan (baza orqali) keladi —
 * shu sabab ular shu yerda `Post` va `Winner` tiplari bilan ta'riflangan:
 * API ulanganda faqat ma'lumot manbai almashadi, sahifalar o'zgarmaydi.
 */

export const BOT_URL = "https://t.me/hovliligabot";

export interface Post {
  slug: string;
  title: string;
  /** ISO sana. */
  date: string;
  /** Ro'yxatda ko'rinadigan qisqa matn. */
  excerpt: string;
  /** Sahifadagi to'liq matn — abzatslar. */
  body: string[];
  tag: string;
}

export interface Winner {
  id: string;
  /** Masalan "2026 — kuzgi mavsum". */
  season: string;
  team: string;
  district: string;
  captain: string;
  played: number;
  won: number;
  rating: number;
}

/**
 * Namunaviy e'lonlar. Haqiqiy ma'lumot ulanguncha sahifa bo'sh turmasin —
 * lekin ular aniq belgilangan, adashib prodga chiqib qolmasin.
 */
export const SAMPLE_POSTS: Post[] = [
  {
    slug: "kuzgi-mavsum-boshlandi",
    title: "Kuzgi mavsum boshlandi",
    date: "2026-09-15",
    tag: "Mavsum",
    excerpt:
      "Toshkentning to'qqiz tumanida mahalla jamoalari ro'yxatdan o'tdi. Birinchi o'yinlar shu hafta oxirida.",
    body: [
      "Kuzgi mavsum uchun ro'yxatdan o'tish yakunlandi. Toshkentning to'qqiz tumanidan jamoalar qo'shildi va birinchi o'yinlar shu hafta oxirida boshlanadi.",
      "Jamoangiz hali ro'yxatdan o'tmagan bo'lsa, botni ochib o'yin yarating — guruhga ulashganingizdan keyin kim kelishini ilova o'zi yig'adi.",
    ],
  },
  {
    slug: "ishonchlilik-bali-qanday-ishlaydi",
    title: "Ishonchlilik bali qanday ishlaydi",
    date: "2026-09-02",
    tag: "Qoidalar",
    excerpt:
      "Yozilib kelmaslik −20 ball, o'yinga uch soatdan kam qolganda chiqish −10. Har bir o'tkazilgan o'yin +2 qaytaradi.",
    body: [
      "Ishonchlilik bali — har bir o'yinchining va'dasiga qanchalik amal qilishini ko'rsatadigan raqam. Hamma 100 balldan boshlaydi.",
      "Yozilib kelmaslik 20 ball, o'yinga uch soatdan kam qolganda ro'yxatdan chiqish 10 ball ayiradi. Har bir o'tkazilgan o'yin esa 2 ball qaytaradi, ya'ni ball vaqt bilan tiklanadi.",
      "Ball e'londa ham, profilda ham ko'rinib turadi — kapitan kimni chaqirayotganini bilib turadi.",
    ],
  },
  {
    slug: "jamoalarga-avtomatik-bolish",
    title: "Jamoalarga avtomatik bo'lish",
    date: "2026-08-21",
    tag: "Yangilik",
    excerpt:
      "Kapitan o'yinchilarga daraja qo'yadi, ilova esa kuchlari teng ikki-to'rt jamoaga bo'ladi.",
    body: [
      "Endi kapitan kelganlarni qo'lda bo'lib o'tirmaydi. Har bir o'yinchiga 1 dan 3 gacha daraja qo'yiladi va ilova jamoalarni darajalar yig'indisi teng bo'ladigan qilib taqsimlaydi.",
      "Darvozabonlar alohida belgilanadi va har jamoaga bittadan tushadi. Natija yoqmasa — qayta aralashtirish tugmasi bor.",
    ],
  },
];

/** Namunaviy g'oliblar jadvali. */
export const SAMPLE_WINNERS: Winner[] = [
  {
    id: "1",
    season: "2026 — yozgi mavsum",
    team: "Chilonzor United",
    district: "Chilonzor",
    captain: "Sardor Karimov",
    played: 18,
    won: 14,
    rating: 1248,
  },
  {
    id: "2",
    season: "2026 — yozgi mavsum",
    team: "Yashnobod FC",
    district: "Yashnobod",
    captain: "Bekzod Sobirov",
    played: 17,
    won: 12,
    rating: 1196,
  },
  {
    id: "3",
    season: "2026 — yozgi mavsum",
    team: "Mahalla Stars",
    district: "Shayxontohur",
    captain: "Otabek Abdullayev",
    played: 16,
    won: 11,
    rating: 1174,
  },
  {
    id: "4",
    season: "2026 — bahorgi mavsum",
    team: "Temiryo'lchi",
    district: "Mirzo Ulug'bek",
    captain: "Doston Nazarov",
    played: 20,
    won: 15,
    rating: 1261,
  },
  {
    id: "5",
    season: "2026 — bahorgi mavsum",
    team: "Sergeli Lions",
    district: "Sergeli",
    captain: "Shohruh Abdullayev",
    played: 19,
    won: 13,
    rating: 1203,
  },
];
